import React, {useContext, useState} from 'react';
import { useLocation, useParams } from 'react-router-dom';
import './PropertyFloorPlans.scss';
import CrusadeBtn from '../../components/crusade/CrusadeBtn';
import Download from "../../static/img/test/download_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24 1.png"
import PDFViewer from '../../components/pdf-viewer/PDFViewer';
import { MainContext } from '../../contexts/MainContext';

export default function PropertyFloorPlans(){
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  const {
    allProperties,
    allGroups,
  } = useContext(MainContext);

  const { cityName, communityName, propertyName } = useParams();
  const communityProperties = allProperties.filter(
    (property) => 
      property.path?.startsWith(`/${cityName}/${communityName}/`) &&
      (property.enabled === undefined || property.enabled === true)
  );

  const communityGroupMarkersProperties = allGroups.map(element => element.modal_map_coords_pin.filter( (property) => property.path.startsWith(`/${cityName}/${communityName}/${propertyName}`))).flat();

  const communityMarkers = [ ...communityProperties, ...communityGroupMarkersProperties ];

  const getPropertyPDF = () => {
    const currentPath = location.pathname;
    const property = communityMarkers.find(item => item.path === currentPath.replace(/\/(floor-plans|documents|others)$/, ""));
    
    if (currentPath.includes('floor-plans')) {
      return property?.pdf;
    } else if (currentPath.includes('documents')) {
      return property?.docs;
    } else if (currentPath.includes('others')) {
      if (typeof property?.others === 'object' && property?.others?.pdf) {
        return property.others.pdf;
      } else {
        return property?.others;
      }
    }
    
    return null;
  };

  // Get the page title based on the current path
  const getPageTitle = () => {
    const currentPath = location.pathname;
    if (currentPath.includes('floor-plans')) {
      return 'Floor Plans';
    } else if (currentPath.includes('documents')) {
      return 'Documents';
    } else if (currentPath.includes('others')) {
      return 'Others';
    }
    return 'PDF Viewer';
  };

  const handlePdfLoaded = () => {
    setIsLoading(false);
  };

  return (
    <div className="floor-plans-container">
      <CrusadeBtn />
      <div className="page-title">{getPageTitle()}</div>
      {getPropertyPDF() && (
        <a 
          href={getPropertyPDF()} 
          download={getPropertyPDF()?.split('/').pop()} 
          className="download-btn">
          <img src={Download} alt="Download" />
          <span>Download pdf</span>
        </a>
      )}
      <PDFViewer pdfURL={getPropertyPDF()} onLoadSuccess={handlePdfLoaded} />
    </div>
  );
};
